import { setLibraryVariables } from "@follosoft/react-components";

import {
  readApiNamespace,
  resolveApiBaseUrl,
} from "@/app/_debug-panel/utils/api-namespace";

/**
 * The API base URL for this page: the build's `VITE_REACT_APP_API_URL`, or —
 * on a dev portal host — the namespaced dev deployment the debug panel pointed
 * this tab at. The panel reloads the page after every change, so this is the
 * base `initEnv` handed the HTTP client at startup.
 */
export const currentApiBaseUrl = (): string =>
  resolveApiBaseUrl(
    import.meta.env.VITE_REACT_APP_API_URL,
    window.location.hostname,
    readApiNamespace(),
  );

/**
 * Run once at startup, before React renders: forwards the env, with the
 * resolved API base, to the component library, whose `axiosInstance()` every
 * request goes through.
 */
export const initEnv = (): void => {
  setLibraryVariables({
    ...import.meta.env,
    VITE_REACT_APP_API_URL: currentApiBaseUrl(),
  });
};
